module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-bg-2-sp-bd512db65e77ae9c3737294c1929f93a.png";